import styled from '@emotion/styled';
import { rgba } from 'polished';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const ModifyingSpan = styled.span(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: rgba(defaultTheme.background.primary, 0.1),
    borderRadius: defaultTheme.border.radius.s,
    color: defaultTheme.color.primary,
    fontSize: defaultTheme.font.size.xs,
    fontWeight: 'bold',
    width: '72px',
    height: '36px',
  }),
);
